import styled from "styled-components";

export const ProcessingContainer = styled.div`
  ${(props) => `
      font-family: ${props.theme.fontFamilies.primaryFont};
  `}
  .img-processing {
    height: 16.6rem;
    width: 17.1rem;
  }
`;
